import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Switch } from '../../../common/html/switch'
import { TooltipEmail } from '../TooltipEmail'
import classes from './index.module.scss'
import { changeSettingOther, selectOtherSetting } from './store/slice'

export const EnableEmail = () => {
  const dispatch = useDispatch()

  const enableEmails = useSelector(selectOtherSetting('enableEmail'))
  const isDisabled = useSelector(selectOtherSetting('disabled'))
  const isDefault = useSelector(selectOtherSetting('isDefault'))

  const handleChange = (isCheck) => {
    dispatch(changeSettingOther({ enableEmail: isCheck }))
  }

  return (
    <div className="flex1">
      <div className="dFlex alignItemsCenter fw600 gap1">
        <TooltipEmail
          contentClass="dFlex alignItemsCenter fw600 gap1 pt1"
          tooltipSpace={2}
          isCreateEdit={false}
          children={(isEmailActive) => (
            <>
              <Translate value="alertSetting.ENABLE_EMAILS" />
              <Switch
                checked={enableEmails}
                onChange={handleChange}
                allowChange={isEmailActive && (!isDisabled || isDefault)}
              />
            </>
          )}
        />
      </div>
      <div className={classes.mt11}>
        <Translate value="alertSetting.ENABLE_EMAILS_DESC" />
      </div>
    </div>
  )
}
